import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_DataInputLog } from '@app/fhir-shared';
export const dispatch_onDataInputLogsUpdated = new ThunderDispatcherV3('__onDataInputLogsUpdated');
export class ModuleFE_DataInputLog_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_DataInputLog, dispatch_onDataInputLogsUpdated);
    }
}
export const ModuleFE_DataInputLog = new ModuleFE_DataInputLog_Class();
//# sourceMappingURL=ModuleFE_DataInputLog.js.map